import React from 'react';
import Icon from '../../../components/AppIcon';

const ConsentManagement = () => {
  const mockConsents = [
    {
      id: 1,
      consentType: 'Marketing Communications',
      totalUsers: 8547,
      consentGiven: 6234,
      consentRate: 73,
      lastUpdated: new Date()?.toISOString()
    },
    {
      id: 2,
      consentType: 'Data Processing',
      totalUsers: 8547,
      consentGiven: 8547,
      consentRate: 100,
      lastUpdated: new Date()?.toISOString()
    },
    {
      id: 3,
      consentType: 'Third-Party Sharing',
      totalUsers: 8547,
      consentGiven: 3421,
      consentRate: 40,
      lastUpdated: new Date()?.toISOString()
    }
  ];

  return (
    <div className="card">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-xl font-heading font-semibold text-foreground">Consent Management</h3>
        <span className="text-sm text-muted-foreground">GDPR Compliance</span>
      </div>
      <div className="space-y-4">
        {mockConsents?.map((consent) => (
          <div key={consent?.id} className="p-4 bg-muted/30 rounded-lg">
            <div className="flex items-center justify-between mb-3">
              <h4 className="text-sm font-medium text-foreground">{consent?.consentType}</h4>
              <span className="text-lg font-semibold text-primary">{consent?.consentRate}%</span>
            </div>

            <div className="relative w-full h-2 bg-muted rounded-full overflow-hidden mb-3">
              <div
                className="absolute top-0 left-0 h-full bg-primary transition-all duration-500"
                style={{ width: `${consent?.consentRate}%` }}
              />
            </div>

            <div className="flex items-center justify-between text-xs text-muted-foreground">
              <span>
                {consent?.consentGiven?.toLocaleString()} of {consent?.totalUsers?.toLocaleString()} users
              </span>
              <span>Updated: {new Date(consent?.lastUpdated)?.toLocaleDateString()}</span>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-6 p-4 bg-info/10 border border-info/20 rounded-lg">
        <div className="flex items-start gap-3">
          <Icon name="Info" size={18} className="text-info mt-0.5" />
          <div>
            <p className="text-sm font-medium text-info mb-1">GDPR Compliance Note</p>
            <p className="text-xs text-muted-foreground">
              All user consents are tracked with timestamps and IP addresses for audit purposes. Users can
              withdraw consent at any time through their account settings.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConsentManagement;